import { useState } from "react";
import { PhoneCall, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { E } from "@/lib/texts";

const EMPTY = { name: "", club: "", phone: "", slot: "", consent: false, website: "" };

export default function CallbackForm() {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try { await api.post("/callback-requests", f); setDone(true); }
    catch (err) { setError(apiError(err)); }
    finally { setBusy(false); }
  };

  if (done) return (
    <div className="card p-6 sm:p-8 flex gap-4 items-start" data-testid="callback-success">
      <CheckCircle2 className="text-[#1E6B45] shrink-0" size={26} />
      <div>
        <p className="font-display text-xl font-bold"><E k="callback.success.title" /></p>
        <p className="text-[15px] text-[#5B665F] mt-1"><E k="callback.success.text" /></p>
      </div>
    </div>
  );

  return (
    <form onSubmit={submit} className="card p-5 sm:p-8 grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="callback-form">
      <label className="block"><span className="field-label"><E k="callback.form.name" /></span><input className="field" required minLength={2} autoComplete="name" value={f.name} onChange={set("name")} data-testid="callback-name-input" /></label>
      <label className="block"><span className="field-label"><E k="callback.form.club" /></span><input className="field" required minLength={2} value={f.club} onChange={set("club")} data-testid="callback-club-input" /></label>
      <label className="block"><span className="field-label"><E k="callback.form.phone" /></span><input className="field" type="tel" required inputMode="tel" autoComplete="tel" placeholder="06 12 34 56 78" value={f.phone} onChange={set("phone")} data-testid="callback-phone-input" /></label>
      <label className="block"><span className="field-label"><E k="callback.form.slot" /> <span className="font-normal text-[#5B665F]">(facultatif)</span></span><input className="field" placeholder="ex. mardi après 18 h" value={f.slot} onChange={set("slot")} data-testid="callback-slot-input" /></label>
      <input type="text" tabIndex={-1} autoComplete="off" className="hidden" value={f.website} onChange={set("website")} aria-hidden="true" />
      <label className="sm:col-span-2 flex gap-3 items-start text-[13px] text-[#5B665F] leading-relaxed cursor-pointer">
        <input type="checkbox" required className="w-4 h-4 mt-0.5 accent-[#1E6B45] shrink-0" checked={f.consent} onChange={set("consent")} data-testid="callback-consent-checkbox" />
        <span><E k="callback.form.consent" /> <Link to="/confidentialite" className="link">Politique de confidentialité</Link></span>
      </label>
      {error && <p className="sm:col-span-2 text-sm text-[#8A4B00] bg-[#FDEBD3] rounded-lg px-3 py-2" data-testid="callback-error">{error}</p>}
      <div className="sm:col-span-2">
        <button className="btn-primary w-full sm:w-auto h-12 px-6" disabled={busy} data-testid="callback-submit-button"><PhoneCall size={16} /> {busy ? "Envoi…" : <E k="callback.form.submit" />}</button>
      </div>
    </form>
  );
}
